module.exports = __webpack_public_path__ + "img/menu1_mobile.f7926126.png";